import React, { useState, useCallback } from 'react';
import PropTypes 						from 'prop-types';
import DildocontrolInfoPopup 			from "../Dildocontrol/DildocontrolInfoPopup";

const ProfileHeaderDildocontrolButton = ({ isOnline, isDildocontrolAvailable }) => {
    const [showPopup, setShowPopup] = useState(false);

    const toggleShowPopup = useCallback(() => {
        setShowPopup(prevShowPopup => !prevShowPopup);
    }, []);

    if (!isOnline || !isDildocontrolAvailable) {
        return null;
    }

    const imgFileName = 'Lovesense-Badge-small.svg';

    return (
        <div className='actor-profile-header__dildocontrol-container'>
            <div className="actor-profile-header__overlay-dildocontrol-outer" onClick={toggleShowPopup}>
                <img className="actor-profile-header__overlay-dildocontrol" src={`/assets/img/dildocontrol/${imgFileName}`} alt="Dildocontrol" />
            </div>

            {showPopup && <DildocontrolInfoPopup onTogglePopup={toggleShowPopup} />}
        </div>
    );
};

ProfileHeaderDildocontrolButton.propTypes = {
    isOnline: 				 PropTypes.bool.isRequired,
	isDildocontrolAvailable: PropTypes.bool.isRequired,
};

export default ProfileHeaderDildocontrolButton;
